import { gql } from "@apollo/client";

export const ORGANISATION_EMPLOYEES = gql`
  query OrganisationEmployees($page: Int, $limit: Int, $search: String) {
    organisationEmployees(page: $page, limit: $limit, search: $search) {
      data {
        _id
        displayName
        firstName
        lastName
        username
        picture
        firebaseId
        organisationRole
        department
        email
        createdAt
      }
      totalCount
      hasMore
    }
  }
`;

export const ORGANISATION_INVITES = gql`
  query OrganisationInvites {
    organisationInvites {
      _id
      email
      firstName
      lastName
      role
      department
      picture
      status
      expiresAt
      createdAt
      inviteLink
    }
  }
`;

export const ORGANISATION = gql`
  query Organisation {
    organisation {
      _id
      logo
      squareLogo
      mapStyle
      embedCta
      name
      slug
      tagline
      description
      website
      email
      phone
      whatsapp
      linkedin
      facebook
      instagram
      tiktok
      country
      city
      zipCode
      streetAddress
      companyType
      businessAccountId
      theme {
        main1
        main2
        main3
        main4
        brandPrimary
        brandSecondary
      }
      milestones {
        firstTripCreated
        firstProposalSent
        brandingConfigured
      }
    }
  }
`;

export const GET_ORGANISATION_INVITE_BY_TOKEN = gql`
  query GetOrganisationInviteByToken($token: String!) {
    getOrganisationInviteByToken(token: $token) {
      _id
      email
      firstName
      lastName
      status
      expiresAt
      organisation {
        _id
        name
        logo
        squareLogo
      }
      invitedBy {
        _id
        displayName
        picture
      }
    }
  }
`;
